import { useState, useEffect } from "react";
import { dataURLtoFile, responseErros, userLogs, voltar } from "../../../utils";
import { FlexLayout } from "../../../layouts";
import {
  MensagemLoteActions,
  MensagemLoteStepper,
  MensagemPersonalizadaForm,
} from "./components";
import {
  CondicionaisService,
  ContasReceberService,
  MensagemPersonalizadaService,
  notification,
  StorageService,
} from "../../../services";
import mensagemPersonalizadaValidator from "./middlewares/add-mensagem-personalizada.validator";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { useImportContext } from "../../../contexts/import.context";
import { MensagemPersonalizada } from "../entities";
import { variaveisDisponiveis } from "../resources/constantes";
import { Button } from "../../../components";
import MenuAddActions from "./components/menu-add-actions.component";
import store from "../../../config/store";
import {
  prepararCorpoRequisicao,
  prepararFiltrosComIntervalo,
} from "../resources/mensagem-personalizada";

const mensagemPersonalizadaService = new MensagemPersonalizadaService();
const storageService = new StorageService();
const permissoesHelper = new PermisoesHelper();
const contasReceberService = new ContasReceberService();
const condicionaisService = new CondicionaisService();

let mensagemPersonalizadaEntity = {
  contexto: null,
  tipo: "SIMPLES",
};

const AddMensagemPersonalizadaView = ({ match }) => {
  const ultimaParteCaminho = window.location.pathname.split("/").pop();
  const msgLote = ultimaParteCaminho === "mensagem-lote";
  const id = !msgLote && match.params.id;
  const { initialCollapses } = useImportContext();
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState(mensagemPersonalizadaEntity);
  const [userLog, setUserLog] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const [emojiAnchorEl, setEmojiAnchorEl] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "mensagens-add-actions-menu";
  const [destinatarios, setDestinatarios] = useState([]);
  const [listaDadosPessoas, setListaDadosPessoas] = useState([]);
  const [rowCount, setRowCount] = useState(null);
  const [imageAnexo, setImageAnexo] = useState(null);
  const [filtros, setFiltros] = useState(null);
  const [steps, setSteps] = useState([
    "Selecione Filtros Clientes",
    "Visualize Clientes",
    "Selecione ou Cadastre mensagem",
  ]);
  const [pessoasSelecionadas, setPessoasSelecionadas] = useState([]);
  permissoesHelper.validarPermisao("mensagem-personalizada-visualizar");
  const envioLote = msgLote || (id && mensagem.tipo === "LOTE");

  useEffect(() => {
    buscarMensagemPersonalizada();
  }, []);

  async function buscarMensagemPersonalizada() {
    setLoading(true);
    if (id) {
      const res = await mensagemPersonalizadaService.getById(id);
      if (!res.isAxiosError) {
        if (!res.data) {
          initialCollapses();
          voltar();
          return;
        }
        mensagemPersonalizadaEntity = new MensagemPersonalizada(res.data);
        setMensagem({ ...mensagemPersonalizadaEntity });
        if (res.data.tipo === "LOTE") {
          await buscarDestinatarios();
        }
      } else {
        responseErros(res);
      }
    } else {
      if (msgLote) {
        mensagemPersonalizadaEntity = new MensagemPersonalizada({
          contexto: null,
          tipo: "LOTE",
        });
        setMensagem({ ...mensagemPersonalizadaEntity });
      } else {
        mensagemPersonalizadaEntity = new MensagemPersonalizada({
          contexto: null,
          tipo: "SIMPLES",
        });
        setMensagem({ ...mensagemPersonalizadaEntity });
      }
    }
    setLoading(false);
  }

  async function buscarDestinatarios(filtros) {
    const filtro = {
      ...filtros,
    };
    mensagemPersonalizadaService
      .getAllDestinatarios(id, filtro)
      .then((result) => {
        if (!result.isAxiosError) {
          setDestinatarios(result.data.rows);
          setRowCount(result.data.count);
        } else {
          responseErros(result);
        }
      });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contexto") setFiltros(null);
    mensagemPersonalizadaEntity.setHandleChangeInput(name, value);
    setMensagem({ ...mensagemPersonalizadaEntity });
  };

  const handleOpenEmojiPicker = (event) => {
    if (event) {
      setEmojiAnchorEl(event.currentTarget);
    } else {
      setEmojiAnchorEl(null);
    }
  };

  const handleEmojiSelect = (emojiData) => {
    mensagemPersonalizadaEntity.setHandleChangeInput(
      "mensagem",
      mensagemPersonalizadaEntity.mensagem + " " + emojiData.emoji
    );
    setMensagem({ ...mensagemPersonalizadaEntity });
    const textarea = document.getElementById("mensagem");
    setTimeout(() => {
      textarea.focus();
      let val = textarea.value;
      textarea.value = "";
      textarea.value = val;
    }, 700);
  };

  const inserirVariavel = (variavel) => {
    const textarea = document.getElementById("mensagem");
    if (textarea) {
      const startPos = textarea.selectionStart;
      const endPos = textarea.selectionEnd;
      const variableText = startPos > 0 ? ` {${variavel}} ` : `{${variavel}} `;
      const mensagemAtual = mensagemPersonalizadaEntity.mensagem;
      mensagemPersonalizadaEntity.setHandleChangeInput(
        "mensagem",
        mensagemAtual
          ? mensagemAtual.substring(0, startPos) +
              variableText +
              mensagemAtual.substring(endPos)
          : variableText
      );
      setMensagem({ ...mensagemPersonalizadaEntity });

      setTimeout(() => {
        textarea.focus();
        textarea.selectionStart = startPos + variableText.length;
        textarea.selectionEnd = startPos + variableText.length;
      }, 300);
    } else {
      mensagemPersonalizadaEntity.setHandleChangeInput(
        "mensagem",
        mensagemPersonalizadaEntity.mensagem + `{${variavel}}`
      );
      setMensagem({ ...mensagemPersonalizadaEntity });
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (envioLote && !filtros?.todosClientes) {
      mensagemPersonalizadaEntity.setListaPessoaIds(pessoasSelecionadas);
    }
    await extrairVariaveis();
    mensagemPersonalizadaValidator
      .validate(mensagemPersonalizadaEntity, { abortEarly: false })
      .then(async () => {
        await createUpdateMensagem();
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  async function extrairVariaveis() {
    const regex = /\{([^}]+)\}/g;
    const variaveis = [];
    let match;
    while ((match = regex.exec(mensagem.mensagem)) !== null) {
      if (variaveisDisponiveis.includes(match[1])) {
        variaveis.push(match[1]);
      }
    }

    mensagemPersonalizadaEntity.setVariaveis(variaveis);
  }

  const enviarAposCadastro = async () => {
    const props = {
      title: "Deseja enviar mensagem?",
      text: "Essa ação não pode ser desfeita",
      icon: "warning",
      confirmButtonText: "ENVIAR",
      cancelButtonText: "<i class='ph-bold ph-x'></i>",
      showCancelButton: true,
    };
    const confirmacaoAlerta = await notification.confirmacaoGenericos(props);
    if (confirmacaoAlerta.isConfirmed) {
      setLoading(true);
      const file = await salvarAnexo();
      const anexo =
        file &&
        `${store.baseUrl}/public/temp/${file}`.replace(/([^:]\/)\/+/g, "$1");
      await contextoEnvio(anexo);
    } else {
      notification.cadastroSucesso();
      voltar();
    }
  };

  function obterServicePorContexto(contexto) {
    const mapService = {
      "condicional-cobranca": condicionaisService,
      "condicional-lembrete": condicionaisService,
      "conta-receber-cobranca": contasReceberService,
      "conta-receber-lembrete": contasReceberService,
    };

    return mapService[contexto] || mensagemPersonalizadaService;
  }

  async function contextoEnvio(anexo) {
    const service = obterServicePorContexto(mensagem.contexto);

    let parametros;
    if (service === mensagemPersonalizadaService) {
      parametros = prepararCorpoRequisicao(
        mensagem.contexto,
        anexo,
        pessoasSelecionadas
      );
    } else {
      parametros = prepararFiltrosComIntervalo(
        mensagem.contexto,
        filtros,
        pessoasSelecionadas
      );
    }

    const result = await service.enviarMensagemLote(parametros);
    if (!result.isAxiosError) {
      notification.cadastroSucesso();
      voltar();
    } else {
      responseErros(result);
    }
  }

  async function salvarAnexo() {
    if (!imageAnexo) return;
    const file = dataURLtoFile(imageAnexo.fileData, imageAnexo.originalName);
    const formData = new FormData();
    formData.append("image", file);
    const resStorage = await storageService.addImageTemp(formData);
    if (!resStorage.isAxiosError) {
      return resStorage.data.fileName;
    } else {
      responseErros(resStorage);
    }
  }

  async function createUpdateMensagem() {
    setLoading(true);
    if (id) {
      const response = await mensagemPersonalizadaService.atualizar(
        id,
        mensagemPersonalizadaEntity
      );
      setLoading(false);
      if (!response.isAxiosError) {
        if (envioLote) {
          return await enviarAposCadastro();
        }
        notification.alteracaoSucesso();
        voltar();
      } else {
        responseErros(response);
      }
    } else {
      const response = await mensagemPersonalizadaService.cadastrar(
        mensagemPersonalizadaEntity
      );
      setLoading(false);
      if (!response.isAxiosError) {
        if (envioLote) {
          return await enviarAposCadastro();
        }
        notification.cadastroSucesso();
        voltar();
      } else {
        responseErros(response);
      }
    }
  }

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(mensagem);
    setUserLog(logs);
  }

  const handleAddActionsOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const title = () => {
    if (msgLote) {
      return "Cadastro de Mensagem Personalizada em Lote";
    }
    return id
      ? "Editar Mensagem Personalizada"
      : "Cadastro de Mensagem Personalizada Simples";
  };

  return (
    <FlexLayout
      id={id}
      title={title()}
      onClickSalvar={handleSubmit}
      loading={loading}
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      showUpdate={permissoesHelper.temPermisao("mensagem-personalizada-editar")}
      nonSubmit={envioLote}
      actions={
        id && envioLote ? (
          <div>
            <Button
              aria-label="add action conta receber"
              aria-controls={menuId}
              aria-haspopup="true"
              aria-expanded={isMenuOpen ? "true" : "false"}
              onClick={handleAddActionsOpen}
              color="inherit"
              style={{
                borderRadius: 5,
                backgroundColor: "#E5E5E5",
              }}
            >
              <span style={{ fontSize: 10 }}>mais ações</span>
            </Button>
          </div>
        ) : null
      }
      footerActions={
        envioLote && (
          <MensagemLoteActions
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            handleSubmit={handleSubmit}
            mensagem={mensagem}
            inputErros={inputErros}
            steps={steps}
            filtros={filtros}
          />
        )
      }
    >
      {envioLote ? (
        <MensagemLoteStepper
          id={id}
          mensagem={mensagem}
          handleChange={handleChange}
          handleOpenEmojiPicker={handleOpenEmojiPicker}
          handleEmojiSelect={handleEmojiSelect}
          inserirVariavel={inserirVariavel}
          emojiAnchorEl={emojiAnchorEl}
          inputErros={inputErros}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          msgLote={msgLote}
          listaDadosPessoas={listaDadosPessoas}
          setListaDadosPessoas={setListaDadosPessoas}
          imageAnexo={imageAnexo}
          setImageAnexo={setImageAnexo}
          filtros={filtros}
          setFiltros={setFiltros}
          steps={steps}
          setSteps={setSteps}
          pessoasSelecionadas={pessoasSelecionadas}
          setPessoasSelecionadas={setPessoasSelecionadas}
        />
      ) : (
        <MensagemPersonalizadaForm
          id={id}
          mensagem={mensagem}
          handleChange={handleChange}
          handleOpenEmojiPicker={handleOpenEmojiPicker}
          handleEmojiSelect={handleEmojiSelect}
          inserirVariavel={inserirVariavel}
          emojiAnchorEl={emojiAnchorEl}
          inputErros={inputErros}
        />
      )}
      <MenuAddActions
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        destinatarios={destinatarios}
        rowCount={rowCount}
        buscarDestinatarios={buscarDestinatarios}
      />
    </FlexLayout>
  );
};

export default AddMensagemPersonalizadaView;
